export default __webpack_public_path__ + "static/media/succes-icon.24e3c968.svg";